import { useState } from 'react';

const faqs = [
  {
    q: 'Preciso de encaminhamento para marcar uma consulta?',
    a: 'Não é necessário encaminhamento. Você pode agendar sua consulta diretamente pelo nosso WhatsApp ou telefone. Basta entrar em contato e escolher o melhor horário para você.',
  },
  {
    q: 'A clínica aceita convênios?',
    a: 'Atendemos por consulta particular e também aceitamos os principais convênios médicos. Entre em contato para verificar se o seu plano é aceito.',
  },
  {
    q: 'Como funciona a primeira consulta?',
    a: 'Na primeira consulta, a Dra. Nathália dedica tempo para conhecer sua história, suas queixas e seus objetivos de saúde. É um momento de escuta e acolhimento, seguido da avaliação clínica necessária.',
  },
  {
    q: 'A colocação do DIU dói?',
    a: 'A Dra. Nathália utiliza técnicas que minimizam o desconforto durante a inserção do DIU. A maioria das pacientes relata apenas um leve incômodo que passa rapidamente. Todo o procedimento é feito com máximo cuidado e respeito ao seu corpo.',
  },
  {
    q: 'Qual a duração média de uma consulta?',
    a: 'Nossas consultas têm duração média de 40 a 60 minutos, pois acreditamos que um atendimento de qualidade não pode ser apressado. Cada paciente recebe o tempo que merece.',
  },
  {
    q: 'Vocês oferecem telemedicina?',
    a: 'Sim, oferecemos consultas por telemedicina para retornos e orientações. Para a primeira consulta, recomendamos o atendimento presencial para uma avaliação mais completa.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" data-cascade className="relative w-full py-28 md:py-40 bg-nude paper-texture overflow-hidden">
      {/* Organic background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[15%] right-[-5%] w-[25%] h-[35%] rounded-full bg-sage-light/5 blur-[100px]" />
        <div className="absolute bottom-[10%] left-[-5%] w-[20%] h-[30%] rounded-full bg-rose-light/6 blur-[80px]" />
      </div>

      <div className="relative max-w-[800px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p data-cascade-label className="font-body text-[10px] md:text-[11px] text-secondary-500 tracking-[0.4em] uppercase mb-3">
            Dúvidas Frequentes
          </p>
          <div data-cascade-line className="w-12 h-[1px] bg-gold-matte/40 mx-auto mb-4" />
          <h2 data-cascade-title className="font-heading text-2xl md:text-3xl lg:text-4xl text-graphite font-light">
            O que você gostaria de{' '}
            <span className="italic">saber</span>?
          </h2>
        </div>

        {/* Accordion */}
        <div className="flex flex-col">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                data-cascade-item
                className="border-b border-secondary-200/30 last:border-b-0"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between py-6 text-left group"
                >
                  <span className="font-body text-sm md:text-base text-graphite/75 font-light pr-8 group-hover:text-graphite transition-colors duration-300">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center relative">
                    <span className="absolute w-3 h-[1px] bg-gold-matte/45 transition-all duration-400" />
                    <span
                      className="absolute w-[1px] h-3 bg-gold-matte/45 transition-all duration-400"
                      style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
                    />
                  </span>
                </button>
                <div
                  className="overflow-hidden transition-all duration-500 ease-in-out"
                  style={{
                    maxHeight: isOpen ? '250px' : '0px',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p className="font-body text-sm text-graphite/55 leading-[1.8] font-light pb-6">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}